<template>
  <div>
    <user-detail-title
      first-bread="供应商"
      second-bread="供应商添加"
      first-url="/user/supply"
      title-name="供应商添加"
    ></user-detail-title>
    <user-detail-base style="height: 81vh">
      <el-form label-position="left" label-width="100px">
        <el-form-item label="公司名称">
          <el-input v-model="Alist.companyName"></el-input>
        </el-form-item>
        <el-form-item label="logo图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="背景颜色">
          <el-color-picker v-model="Alist.colour" show-alpha></el-color-picker>
        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "SupplyAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        Large:{},
        Small:{},
        Alist: {
          'companyName':null,
          'logoUrl':null,
          'colour':null,
        },//表示Add添加的数据
      }
    },
    methods:{
      GetUrlList(file){
        this.Alist.logoUrl=file.data;
      },
      handleAdd(){
        this.$axios.post('/api/supplier/add',this.Alist).then(res=>{
          if(res.data.success == true){
            this.Alist= {
              'companyName':null,
              'logoUrl':null,
              'colour':null,
            }//表示Add添加的数据,
            this.$message({
              message:'添加成功',
              type:'success'
            })
          }
        })
      }
    },
  }
</script>

<style scoped>

</style>